import { useServicesChartsDataContext } from './useServicesChartsDataContext';
import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Common/Util/getMonthsByYear';
import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';

export const useCompareValuesPerYearPerMonthPercentage = () => {
    const { chartData, filters } = useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const series = months.map((month) => {
        const found = chartData.selectedYear.find(
            (counter) =>
                parseInt(counter.mes_competencia, 10) === monthsIndexes[month]
        );

        if (!found) {
            return 0;
        }

        return (
            Number(
                Number(found.valor_aprovado) / Number(found.valor_produzido)
            ) * 100
        );
    });

    const chartConfig = {
        series: [
            {
                name: 'Efícacia',
                data: series
            }
        ],
        options: {
            chart: {
                type: 'bar',
                height: 200,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last',
                    horizontal: false,
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            dataLabels: {
                enabled: true,
                position: 'top',
                formatter: (val) => `${val.toFixed(2)}%`,
                style: {
                    colors: ['#333'],
                    fontSize: '11px'
                },
                offsetX: 0,
                offsetY: -20
            },
            xaxis: {
                categories: months
            },
            yaxis: {
                labels: {
                    formatter: (val) => `${val.toFixed(0)}%`
                }
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1,
                colors: defaultColors
            },
            tooltip: {
                y: {
                    formatter: (val) => (val ? `${val.toFixed(2)}%` : '')
                }
            },
            colors: defaultColors,
            grid: {
                show: false
            }
        }
    };
    return {
        chartConfig
    };
};
